import React, {Component} from 'react';
import {Redirect, withRouter} from 'react-router-dom';
import LoadingComponent from "../../common/loadingComponent";
import {getAllConfigs} from "../../../../services/configsService";
import ConfigsForm from "./ConfigsForm";

class LoadConfigsForm extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : true,
        userToken : this.props.user,
        configs : {},
        locale : this.props.locale
    };


    componentDidMount() {
        this._isMounted = true;
        this.onLoadDATA();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadDATA = async () =>{
        try {
            this.setState({isLoading:true});
            const {data: configs} = await getAllConfigs();
            if (this._isMounted){
                this.setState({
                    configs,
                    isLoading: false
                });
            }

        }  catch(err)  {
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }


    renderPage = () => {
        return (
          <>
              <ConfigsForm
                  isAdminForm = {(this.props.id)?true:false}
                  locale = {this.props.locale}
                  configs = {this.state.configs}
              />
          </>
        );
    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
            </>
        );
    }
}

export default withRouter(LoadConfigsForm);
